import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import QuickInquiry from './components/QuickInquiry';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <QuickInquiry />
      <Products />
      <About />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
